<template>
    <div>
        <a href="javascript:void" @click="downloadFile">{{ currentModel != null ? currentModel.originalFilename : "" }}</a>
    </div>
</template>
<script>
import { saveAs } from 'file-saver';
export default {
    components: {},
    props: ["model", "currentModel", "errorMessage", "isEditable", "maxFileSize", "label", "isRequired"],
    data() {
        return {
            labelStr: this.label,
            inputModel: this.model,
            inputErrorMessage: '',
            isReupload:false,
        }
    }, 
    methods: {
        setUploadFile(event) {
            if (event.target.files.length > 0) {
                let file = event.target.files[0];
                if (this.maxFileSize != null && this.maxFileSize != undefined) {
                    let fileSize = (file.size / 1048576).toFixed();
                    if (fileSize > this.maxFileSize) {
                        alert("Max Allowed File Size " + this.maxFileSize + " MB");
                        this.inputModel = null;
                        return;
                    }
                }
                this.inputModel = file;
                this.$emit('update:model', this.inputModel);
                this.$emit('change');
            }
        },
        async downloadFile() {
            if (this.currentModel != null) {
                let url = process.env.VUE_APP_API_URL + 'attachment/download/' + this.currentModel.id;
                let fileName = this.currentModel.originalFilename;
                this.$http.get(url, {responseType: 'blob'}).then(response => {
                    if (response != null) {
                        saveAs(response.data, fileName);
                    }
                }).catch(error => {
                    this.$store.dispatch('addErrorMessageGlobal', error);
                    throw error;
                })
                
            }
        },
        reuploadFile() {
            this.isReupload = true;
            this.inputModel = null;
            this.$emit('update:model', this.inputModel);
            this.$emit('change', "reupload");
        },
        clearFiles() {
            this.$refs['file-input'].reset()
        }
    },
     computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        }
    },
    watch: {
        currentModel(newValue, oldValue) {
            this.isReupload = false;
        },
        model(newValue, oldValue) {
            if (newValue == null) {
                this.clearFiles();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
:deep  .modal-dialog {
    height: 70vh;
    width: 60vh;
}
.input-group-text {
    font-size: 0.7rem !important;
}

.btn-open-camera {
    padding: 1px 6px !important;
}

.barcode-text {
    font-size: 2rem;
    text-align: center;
}

</style>